import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { LessonModel, TopicModel } from '@generativ/much-smarter-models';

import { environment } from '../../../../../environments/environment';
import { ErrorHandlerService } from '../../../../core/services/error-handler.service';
import { ProblemService } from './problem.service';

@Injectable({ providedIn: 'root' })
export class LessonService {

  private lesson: Observable<LessonModel>;
  private lessonId: number;
  private lessonUrl = environment.msStudentApiUrl + 'lessons/';
  private lessonProgressUrl = environment.msStudentApiUrl + 'progress/';

  constructor(private http: HttpClient,
              private errorHandlerService: ErrorHandlerService,
              private problemService: ProblemService) {
  }

  getLesson(id: number): Observable<LessonModel> {
    if (!this.lesson || this.lessonId !== id) {
      this.lessonId = id;
      this.lesson = this.http.get<LessonModel>(this.lessonUrl + id).pipe(
        catchError(this.errorHandlerService.handleError));
    }

    return this.lesson;
  }

  getTopics(id: number): Observable<TopicModel[]> {
    return this.http.get<TopicModel[]>(this.lessonProgressUrl + 'getTopics/' + id).pipe(
      catchError(this.errorHandlerService.handleError));
  }

  identifyTopicForLesson(id: number, topicId: number): Observable<number> {
    return this.http.get<number>(this.lessonProgressUrl + 'identifyTopic/' + id).pipe(
      catchError(this.errorHandlerService.handleError));
  }
}
